import { OrderBuilderActions, RESET_BUILDER } from '../../../actions/order-builder.actions';
import { AddedValueActionTypes, AddedValuesActions } from '../actions/added-values.actions';
import { AddedValue } from '../models/added-values';
import { TechnicalProduct } from '@cemex-core/cmx-api';

export interface AddedValueTuple {
  loading: boolean;
  addedValues: AddedValue[];
  technicalProduct: TechnicalProduct[];
}

export interface AddedValuesState {
  availableAddedValues: {
    [productCode: string]: AddedValueTuple[];
  };
}

export const initialState: AddedValuesState = {
  availableAddedValues: {},
};

/**
 * Makes tuple state into loading state given index
 * Will remove further tuples from index
 * @param state
 * @param index
 */
const loadTupleState = (state: AddedValueTuple[], index: number) => {
  if (index === 0) {
    state = [];
  } else {
    state.splice(index + 1, state.length - (index + 1));
  }

  state[index] = {
    addedValues: undefined,
    technicalProduct: [],
    loading: true,
  };

  return state;
};

/**
 * Makes a tuple state into a complete mode
 * Adds available added values options into given index
 * @param state
 * @param addedValues
 * @param index
 */
const completeTupleState = (
  state: AddedValueTuple[],
  addedValues: AddedValue[],
  technicalProduct: TechnicalProduct[],
  index: number,
) => {
  return (
    !!state &&
    state.map((tuple, i) => {
      if (i === index) {
        return {
          addedValues: addedValues,
          technicalProduct: technicalProduct,
          loading: false,
        } as AddedValueTuple;
      } else {
        return tuple;
      }
    })
  );
};

export function addedValuesReducer(
  state = initialState,
  action: AddedValuesActions | OrderBuilderActions,
): AddedValuesState {
  switch (action.type) {
    case AddedValueActionTypes.CLEAN_NULL_ADDED_VALUES: {
      const keys = Object.keys(state.availableAddedValues).map(k => Number(k));
      const _state = { ...state };
      keys.forEach(productCode => {
        const clean = state.availableAddedValues[productCode].filter(
          ({ addedValues, technicalProduct }) => addedValues !== null && technicalProduct !== null,
        );
        _state.availableAddedValues[productCode] = clean;
      });
      return {
        ...state,
        availableAddedValues: {
          ..._state.availableAddedValues,
        },
      };
    }
    case AddedValueActionTypes.LOAD_ADDED_VALUES_NOT_FORMULATING:
    case AddedValueActionTypes.LOAD_ADDED_VALUES: {
      return {
        ...state,
        availableAddedValues: {
          ...state.availableAddedValues,
          [action.payload.productCode]: loadTupleState(
            state.availableAddedValues[action.payload.productCode],
            action.payload.index,
          ),
        },
      } as AddedValuesState;
    }
    case AddedValueActionTypes.LOAD_AVAILABLE_ADDED_VALUES_COMPLETED: {
      return {
        ...state,
        availableAddedValues: {
          ...state.availableAddedValues,
          [action.payload.productCode]: completeTupleState(
            state.availableAddedValues[action.payload.productCode],
            action.payload.addedValues,
            action.payload.technicalProduct,
            action.payload.index,
          ),
        },
      } as AddedValuesState;
    }
    case RESET_BUILDER:
    case AddedValueActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
